import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const ArrowUpIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-arrow-up-icon ${className}`, height: '10', viewBox: '0 0 7 10', width: '7', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsxs("g", Object.assign({ transform: 'translate(-735 -5633)' }, { children: [_jsx("path", { d: 'M3.5,0,7,6H0Z', fill: '#fff', transform: 'translate(735 5633)' }), _jsx("rect", { fill: '#fff', height: '4', transform: 'translate(737 5639)', width: '3' })] })) })));
ArrowUpIcon.propTypes = {
    className: propStr(),
};
ArrowUpIcon.defaultProps = {
    className: '',
};
export default ArrowUpIcon;
